export default {
    methods: {
        todaySeconds() {
            let today = DateTime.now().setZone(this.$store.state.tenant.timezone)
            return today.hour * 3600 + today.minute * 60 + today.second
        },
        listOfHours() {
            let list = []
            for (let seconds = 0; seconds < 86400; seconds += 900) {
                list.push({
                    label: this.toHour(seconds),
                    value: seconds
                })
            }
            return list
        },
        to24Hour(seconds) {
            seconds = parseInt(seconds)
            let hour = parseInt(seconds / 3600)
            let minutes = parseInt( (seconds / 60) - hour * 60 )
            return String(hour) + ':' + String(minutes).padStart(2,'0')
        },
        toHour(seconds) {
            seconds = parseInt(seconds)
            let hour = parseInt(seconds / 3600)
            let minutes = parseInt( (seconds / 60) - hour * 60 )

            let zone = 'AM'

            if (hour >= 24) {
                zone = 'AM'
                hour = hour - 24
            }
            else if (hour >= 12) {
                zone = 'PM'
                hour = hour - 12
            }


            if (hour == 0) hour = 12

            return String(hour) + ':' + String(minutes).padStart(2,'0') + '' + zone
        },

        toDayHour(seconds) {
            seconds = parseInt(seconds)
            let hour = parseInt(seconds / 3600)
            let minutes = parseInt( (seconds / 60) - hour * 60 )
            let left_seconds = seconds - hour * 3600 - minutes * 60

            return String(hour).padStart(2,'0') + ":" + String(minutes).padStart(2,'0') + ":" + String(left_seconds).padStart(2,'0')
        },

        toDateTimeObject(date, seconds, timezone) {
            const date_full = date + "T" + this.toDayHour(seconds) + " " + timezone
            return DateTime.fromFormat(date_full, "yyyy-MM-dd'T'HH:mm:ss z")
        },

        toMinutes(total_seconds) {

            let minutes = parseInt(total_seconds/60)
            let seconds = total_seconds - 60 * minutes

            if (minutes == 0) {
                return seconds
            }

            return minutes + ':' + String(seconds).padStart(2,'0')
        },

        toDuration(total_seconds) {
            let hours = parseInt(total_seconds/3600)
            let minutes = parseInt((total_seconds - 3600 * hours)/60)

            if (hours == 0) {
                return minutes + '' + this.__('m')
            }

            let duration = hours + '' + this.__('h')
            if (minutes >0 ){
                duration += ' ' + minutes + '' + this.__('m')
            }

            return duration
        },

        toListOptions(durations) {
            let list = []
            for(let i = 0; i < durations.length; i++){

                let minutes = durations[i].match(/(\d+)min/)
                minutes = minutes ? parseInt(minutes[1]) : 0

                let hours = durations[i].match(/(\d+)h/)
                hours = hours ? parseInt(hours[1]) : 0

                let days = durations[i].match(/(\d+) days/)
                days = days ? parseInt(days[1]) : 0

                let label = this.__(durations[i])
                let value = minutes * 60 + hours * 3600 + days * 86400
                if (value == 0)  {
                    label = this.__(durations[i]).toUpperCase()
                    value = durations[i]
                }

                list.push({
                    label: label,
                    value: value
                })
            }
            return list
        },

    }
}
